import _extends from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React from 'react';
import { TouchableWithoutFeedback, View } from 'react-native';

var RNGestureHandlerButton =
/*#__PURE__*/
function (_React$Component) {
  _inherits(RNGestureHandlerButton, _React$Component);

  function RNGestureHandlerButton() {
    _classCallCheck(this, RNGestureHandlerButton);

    return _possibleConstructorReturn(this, _getPrototypeOf(RNGestureHandlerButton).apply(this, arguments));
  }

  _createClass(RNGestureHandlerButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          rest = _objectWithoutProperties(_this$props, ["children"]);

      return React.createElement(TouchableWithoutFeedback, _extends({
        accessibilityRole: "button"
      }, rest), React.createElement(View, null, children));
    }
  }]);

  return RNGestureHandlerButton;
}(React.Component);

export { RNGestureHandlerButton as default };